module.exports = __webpack_public_path__ + "img/6.37803e16.jpg";